import * as React from 'react';
import Box from '@mui/material/Box';
import { Div, Progress, Container } from './styles';

const ConsultantProgressData = ({ value, maxValue, title }) => {
    const percent = maxValue > 0 ? ((value / maxValue) * 100).toFixed(0) : 0;
    return (
        <Container>
            <h3>{title}</h3>
            <Div>
                <p>
                    {value}/{maxValue} Consultores
                </p>
                <h2>{value === 0 ? 0 : percent}%</h2>
            </Div>
            <Box sx={{ width: '100%' }}>
                <Progress variant="determinate" bordercolor="#62C054" value={value === 0 ? 0 : percent} color="success" />
            </Box>
        </Container>
    );
};

export default ConsultantProgressData;
